import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-layout-blank',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './layout-blank.component.html',
  styleUrl: './layout-blank.component.scss'
})
export class LayoutBlankComponent {

}
